
import http from '@/utils/http.js'
import axios from 'axios'
import { getCookie } from '@/utils/token'

let api = {
	videoCategorySave: "/api/video/category/save",
	videoCategoryList: '/api/video/category/list',
  videoCategoryDelete: '/api/video/category/delete',
	videoSave: "/api/video/save",
	videoList: '/api/video/list',
  videoDelete: '/api/video/delete',
	spriteCategorySave: "/api/sprite/category/save",
	spriteCategoryList: '/api/sprite/category/list',
	spriteCategoryDelete: '/api/sprite/category/delete',
	spriteGroupSave: "/api/sprite/group/save",
	spriteGroupList: '/api/sprite/group/list',
	spriteGroupDelete: '/api/sprite/group/delete',

	spriteSave: "/api/sprite/save",
	spriteList: '/api/sprite/list',
	spriteDelete: '/api/sprite/delete',
	soundCategorySave: "/api/sound/category/save",
	soundCategoryList: '/api/sound/category/list',
	soundCategoryDelete: '/api/sound/category/delete',
	soundSave: "/api/sound/save",
	soundList: '/api/sound/list',
	soundDelete: '/api/sound/delete',
	userList: '/api/user/list',
	userMenberEdit: '/api/user/menberEdit',
	importUser: '/api/user/import',
	userDelete: '/api/user/delete',

	// 用户管理（管理端，adminAuth 保护）
	userManageList: '/api/user/manageList',
	userManageSave: '/api/user/manageSave',
	userManageUpdate: '/api/user/manageUpdate',
	userManageDelete: '/api/user/manageDelete',
	userManageBatchStatus: '/api/user/manageBatchStatus',
	userManageBatchDelete: '/api/user/manageBatchDelete',
	userManageImport: '/api/user/manageImport',
	userManageExport: '/api/user/manageExport',
	// 机构列表（用户管理筛选/表单下拉共用）
	organizationList: '/api/organization/list',
	// 子账户信息修改申请审批（管理端，adminAuth 保护）
	manageChangeRequestList: '/api/user/manageChangeRequest/list',
	manageChangeRequestApprove: '/api/user/manageChangeRequest/approve',
	manageChangeRequestReject: '/api/user/manageChangeRequest/reject',

	aiList: "/api/coze/list",

	// 管理员登录（拿 token）
	adminLogin: "/api/login",
	// 用户资产管理（需 adminAuth）
	adminAssetList: "/api/admin/asset/list",
	adminAssetDelete: "/api/admin/asset/delete",
	adminAssetStatistics: "/api/admin/asset/statistics",
	// AI 生成过程记录（学生 AI 素养评估数据，需 adminAuth）
	aiGenerationList: "/api/admin/aigeneration/list",
	// 作品库 / 作品族血缘成长线（学生 AI 素养评估数据，需 adminAuth）
	adminProjectList: "/api/admin/project/list",
	adminProjectFamily: "/api/admin/project/family",
}

// 同源相对路径：经 nginx /api 代理到后端，开发/生产通用
export const baseUrl = "";
export const uploadUrl = "/api/upload";

export const videoCategorySaveFn = (data) => {
	return http.post(api.videoCategorySave, data);
}

export const videoCategoryListFn = (data) => {
	return http.post(api.videoCategoryList, data);
}

export const videoCategoryDeleteFn = (data) => {
	return http.post(api.videoCategoryDelete, data);
}

export const videoSaveFn = (data) => {
	return http.post(api.videoSave, data);
}

export const videoListFn = (data) => {
	return http.post(api.videoList, data);
}

export const videoDeleteFn = (data) => {
	return http.post(api.videoDelete, data);
}

export const spriteCategorySaveFn = (data) => {
	return http.post(api.spriteCategorySave, data);
}

export const spriteCategoryListFn = (data) => {
	return http.post(api.spriteCategoryList, data);
}

export const spriteCategoryDeleteFn = (data) => {
	return http.post(api.spriteCategoryDelete, data);
}

export const spriteGroupSaveFn = (data) => {
	return http.post(api.spriteGroupSave, data);
}

export const spriteGroupListFn = (data) => {
	return http.post(api.spriteGroupList, data);
}

export const spriteGroupDeleteFn = (data) => {
	return http.post(api.spriteGroupDelete, data);
}


export const spriteSaveFn = (data) => {
	return http.post(api.spriteSave, data);
}

export const spriteListFn = (data) => {
	return http.post(api.spriteList, data);
}

export const spriteDeleteFn = (data) => {
	return http.post(api.spriteDelete, data);
}

export const soundCategorySaveFn = (data) => {
	return http.post(api.soundCategorySave, data);
}

export const soundCategoryListFn = (data) => {
	return http.post(api.soundCategoryList, data);
}

export const soundCategoryDeleteFn = (data) => {
	return http.post(api.soundCategoryDelete, data);
}

export const soundSaveFn = (data) => {
	return http.post(api.soundSave, data);
}

export const soundListFn = (data) => {
	return http.post(api.soundList, data);
}

export const soundDeleteFn = (data) => {
	return http.post(api.soundDelete, data);
}

export const userListFn = (data) => {
	return http.post(api.userList, data);
}

export const userMenberEditFn = (data) => {
	return http.post(api.userMenberEdit, data);
}

export const userImportFn = (data) => {
	return http.post(api.importUser, data);
}

export const deleteUserByIdsFn = (data) => {
	return http.post(api.userDelete, data);
}

export const aiListFn = (data) => {
	return http.post(api.aiList, data);
}
// AI 生成过程记录（管理端查询）
export const aiGenerationListFn = (data) => {
	return http.post(api.aiGenerationList, data);
}

// 管理员登录（拿真 token，存 localStorage 供 adminAuth 使用）
export const adminLoginFn = (data) => {
	return http.post(api.adminLogin, data);
}
// 用户资产管理
export const adminAssetListFn = (data) => {
	return http.post(api.adminAssetList, data);
}
export const adminAssetDeleteFn = (data) => {
	return http.post(api.adminAssetDelete, data);
}
export const adminAssetStatisticsFn = (data) => {
	return http.post(api.adminAssetStatistics, data);
}

// 管理端作品库分页查询（姓名/账号/作品名模糊）
export const adminProjectListFn = (data) => {
	return http.post(api.adminProjectList, data);
}

// 管理端作品族：查询某作品所在血缘成长线
export const adminProjectFamilyFn = (data) => {
	return http.post(api.adminProjectFamily, data)
}

// ===== 用户管理（管理端，adminAuth）=====
export const userManageListFn = (data) => {
	return http.post(api.userManageList, data)
}
export const userManageSaveFn = (data) => {
	return http.post(api.userManageSave, data)
}
export const userManageUpdateFn = (data) => {
	return http.post(api.userManageUpdate, data)
}
export const userManageDeleteFn = (data) => {
	return http.post(api.userManageDelete, data)
}
export const userManageBatchStatusFn = (data) => {
	return http.post(api.userManageBatchStatus, data)
}
export const userManageBatchDeleteFn = (data) => {
	return http.post(api.userManageBatchDelete, data)
}
// 机构列表（下拉选项）
export const organizationListFn = (data) => {
	return http.post(api.organizationList, data)
}
// 导出：POST 返回 CSV 附件，需二进制响应 + 手动带 token（绕过 http 拦截器的 JSON 处理）
export const userManageExportFn = (data) => {
	return axios.post(api.userManageExport, data, {
		responseType: 'blob',
		headers: { token: getCookie('token') || '' },
	})
}

// 子账户信息修改申请审批（管理端，adminAuth 保护）
export const manageChangeRequestListFn = (data) => {
	return http.post(api.manageChangeRequestList, data)
}
export const manageChangeRequestApproveFn = (data) => {
	return http.post(api.manageChangeRequestApprove, data)
}
export const manageChangeRequestRejectFn = (data) => {
	return http.post(api.manageChangeRequestReject, data)
}